export const i18nEventPage = {
  alarm: 'Alarm',
  alarm_and_period: 'Alarm + risk period',
  closed_alarm: 'Closed alarm',
  expand: 'Expand list',
  expand_tutorial_title: 'Introducing Visual Insights',
  expand_tutorial_description:
    'Your Alarm list now includes charts for quick insights. Use "Expand List" to switch back to the full list view.',
  expand_tutorial_button: 'Got it',
  show_analytics: 'Show Analytics',
  grid: {
    ack_status: 'Acknowledgement Status',
    alarms: 'Alarms',
    acked: 'Acknowledged',
    new: 'New',
  },
  automatic_ack_info: {
    text: '<strong>{{models}} models</strong> are set with auto-ack. <strong>{{alarms}} alarms</strong> were auto acknowledged in the selected period.',
    view_models: 'View models',
    view_alarms: 'View alarms',
  },
  analytics: {
    bar_chart_title: 'Alarms by period',
    day: 'Daily',
    week: 'Weekly',
    month: 'Monthly',
    year: 'Yearly',
    hour: 'Hourly',
  },
  automatic_ack_models: {
    title: 'Models with auto acknowledge enabled',
  },
  sections: {
    prediction_graph: 'Failure risk model',
    pump_curve: 'Pump curve',
    sensors_graph: 'Sensors data',
    analysis: 'Analysis',
    history: 'Historic',
    event_list: 'Latest events {{asset}}',
    flat_line_graph: 'Flat line',
    diagnostic: 'Diagnostic',
    recommendation: 'Recommendations',
  },
  charts_tabs: {
    features: 'Features',
    feature: 'Features',
    sujidade: 'Dirt',
    sensors: 'Sensors',
    sensor: 'Sensors',
    amoeba: 'Plot view',
    plot: 'Plot view',
    radar: 'Radar view',
    risk: 'Risk Score',
  },
  event: {
    sections: {
      details: 'Details',
      prognosis: 'Prognosis',
      radar: 'Radar view',
      amoeba: 'Plot view',
      sensors: 'Sensors',
      sensor: 'Sensors',
      risk: 'Risk Score - Alarm',
      feature: 'Feature',
    },
  },

  components: {
    relatedTables: {
      events: 'Similar Alarms',
      condition_deviations: 'Condition Deviations',
      sap_notes: 'Maint. Notes',
      cases: 'Cases',
    },
    alarmScalingModels: {
      tabs: { alarm_history: 'Alarm History', scaling_models: 'Process Models' },
    },
    similarEvents: {
      no_data: 'There is no record of a similar event acknowledged in the last year',
      text: 'Similar event detected on {{eventDate}} - {{useful}} {{eventComments}} ',
      button: 'Open',
    },
    similarEventsList: {
      title: 'Latest occurrences of this alarm',
      btn: 'Similar Alarms',
      empty_message: 'No alarms for this asset in the selected period.',
    },
    eventFooter: {
      btns: {
        maintenance: 'Maint. notes',
        assetPage: 'Asset page',
        cds: 'Cond. Dev.',
        records: 'Records',
        ack: 'Acknowledge',
        reclassify: 'Reclassify',
        cases: 'Cases',
      },
    },
    maintenanceModal: 'Maintenance Notes',
    cdListModal: 'Asset Condition Deviations',
    modalAck: {
      title: { OPEN: 'Acknowledge this alarm', CLOSED: 'Reclassify this alarm' },

      labels: {
        classification: 'Classification',
        why_not_useful: 'Why is it not useful?',
        comments: 'Comments',
        willAssociateCD: 'Is there a need to be addressed by a Condition Deviation?',
        next_step: 'Next step',
        NO_ACTION: 'No action',
        ATTACH_ALARM_TO_AN_EXISTING_CASE_TITLE: 'Add alarm to an existing Case',
        ATTACH_ALARM_TO_AN_EXISTING_CASE: 'Attach alarm to an existing Case ({{quantity}} open)',
        CREATE_NEW_CASE_AND_ATTACH_ALARM: 'Create new Case and attach alarm',
      },

      btns: {
        ack: 'Acknowledge',
        cancel: 'Cancel',
        confirm: 'Confirm',
      },
      placeholders: {
        comments: 'Please, share any relevant information about this alarm',
        select_an_option: 'Select an option',
      },

      required_field: 'Required field',
    },
    btns: {
      PI: 'Go to PI',
      Expand: 'Expand',
    },
    conditions_related: {
      viewCds: 'View asset Condition Deviations',
      newCd: 'Open new CD',
      fullCdPage: 'Full CD Page',
    },
    event_summary: {
      start_time: 'Start',
      end_time: 'End',
      asset_name: 'Asset',
      description: 'Event description',
      status: 'Status',
      classification: 'Classification',
      model: 'Model',
      id: 'Event id',
      alarms_count: 'Alarms',
    },
    analysis: {
      fields: {
        status: 'Status',
        classification: 'Classification',
        action: 'Operator action',
        work_order: 'Work order (number)',
        reason: 'Reason',
        failure_occurred: 'There was failure?',
        additional_info: 'Additional info',
        end_date: 'Estimate to complete investigation',
      },
      actions: {
        attach: 'Attach file',
        save: 'Save',
        attachments: 'Attachments',
        required_field: 'Required field',
        max_length: 'Max size {{size}} characters',
      },
    },
    history: {
      comment_placeholder: 'Leave a comment',
      empty_history: 'Event without change history',
      item: {
        template: {
          action: {
            insert: 'inserted',
            update: 'updated',
            delete: 'deleted',
            attach: 'attached',
          },
          title: '{{author}} {{action}} {{attribute}}',
          message: {
            text: '{{text}}',
            from_to: 'From {{previous}} to {{current}}',
          },
        },
      },
    },
    sensors_graphic: {
      variables_contribution: 'Variables contribution',
      all_sensors: 'All sensors',
      all_features: 'All features',
    },
    alarmsByAlgorithmTable: {
      description: 'Models',
      bar: 'Alarms',
      count: '#',
      dataOptions: {
        models: 'Models',
        assets: 'Assets',
      },
    },
  },
  message: {
    no_data: {
      message: 'No Alarms in the period and filters selected',
    },
    generic_error: {
      title: 'Ops..',
      message: 'Unexpected error occurred. Try again on few minutes',
    },
    inexistent_event: {
      title: 'Event not found',
      message: 'Please try with a valid event id',
    },
    features_contribution_error: {
      title: 'Ops..',
      message: 'An error occurred to load features contribution data',
    },
    analysis_submit: {
      success: { title: 'Success', message: 'Analysis submited' },
      error: { title: 'Error', message: 'Analysis submit failure' },
    },
    empty_historic: {
      title: 'Empty historic',
      message: 'There is no updates for this Event',
    },
    historic_error: {
      title: 'Historic load error',
      message: 'Try again in few minutes',
    },
    comment_submit: {
      success: { title: 'Success', message: 'Comment submited' },
      error: { title: 'Error', message: 'Comment submit failure' },
    },
  },
  severity: {
    VERY_HIGH: 'Very High',
    HIGH: 'High',
    MEDIUM: 'Medium',
    LOW: 'Low',
    Information: 'Low',
    Warning: 'Low',
    Minor: 'Medium',
    Major: 'High',
    Critical: 'Very High',
  },
  status_count_panel: {
    empty_data: 'No data available to filter',
    total: { caption: 'Alarms' },
    severity: {
      title: 'Severity',
      4: 'Very High',
      3: 'High',
      2: 'Medium',
      1: 'Low',
    },
    status: {
      total: { title: 'Total', total: 'Alarms' },
      status: {
        title: 'Status',
        OPEN: 'New',
        CLOSED: 'Acknowledged',
        total: 'Total by period',
      },
      classification: { title: 'Classification', USEFUL: 'Useful', NOT_USEFUL: 'Not Useful' },
    },
  },
  no_data: 'No data available',

  main_tabs: {
    OPEN: 'New',
    CLOSED: 'Acknowledged',
    ALL: 'All',
  },
  no_prognosis: 'No prognostic available for this event',
  event_details: {
    id: 'ID',
    severity: 'Severity',
    alarm_datetime_start: 'Start',
    alarm_datetime_end: 'End',
    duration: 'Duration',
    method: 'Method',
    category: 'Category',
    vessel: 'Vessel',
    system: 'System',
    subsystem: 'Subsystem',
    asset: 'Asset',
  },

  tag: {
    alarms: 'Alarms',
    aggregated: 'Aggregated',
  },
  filters: {
    all_assets: 'All Assets',
    all_categories: 'All categories',
    search: 'Search',
  },
  table: {
    severity: 'Sever.',
    description: 'Name',
    vessel: 'Vessel',
    system: 'System',
    subsystem: 'Subsystem',
    asset: 'Asset',
    alarm_datetime_start: 'Start',
    duration: 'Duration',
    classification: 'Classific.',
    closed_by: 'Closed by',
    records: 'Records',
    status: 'Status',
    agreg: '#',
    link: '',
    id: 'ID',
    checkbox: '',
    see_event: 'See event',
    model_label: 'Model Name',
    case_name: 'Case ',
    number_of_alarms: 'Alarms (period)',
    asset_name: 'Asset',
  },

  useful_modal: {
    withCds: {
      title: 'Alarm acknowledged. Check asset Condition Deviations?',
      text: 'The alarm has been saved as Useful. Do you want to check if there is an open Condition Deviation to investigate this issue?',
      action: 'Yes, check asset Condition Deviations',
      cancelBtn: 'No, thanks',
    },
    withoutCds: {
      title: 'Alarm saved. Open new Condition Deviation?',
      text: 'The alarm has been saved as Useful. Do you wish to open a new Condition Deviation to investigate the issue?',
      action: 'Yes, open CD',
      cancelBtn: 'No, thanks',
    },
  },
  expanded_charts: {
    tabs: {
      alarm_related_charts: 'Alarm related charts',
      equipment_sensors: 'Equipment sensors',
    },
  },
  chart_status: {
    status: { OPEN: 'Open', CLOSED: 'Closed' },
    classification: { USEFUL: 'Useful', NOT_USEFUL: 'Not Useful' },

    whyNotUseful: {
      PROCESS_INSTABILITY: 'Process instability',
      PRODUCTION_RESTART: 'Production restart',
      INSTRUMENT_ERROR: 'Instrument error',
      PROCESS_CHANGE: 'Process change',
      TESTS_IN_PROGRESS: 'Tests in progress',
      INAPPROPRIATE_LIMITS: 'Inappropriate limits',
      UNCALIBRATED_MODEL: 'Uncalibrated model',
      THERE_IS_NO_CERTAINTY: 'There is no certainty',
      THERE_IS_NO_CERTAINITY: 'There is no certainty',
      MACHINE_IS_OFF: 'Equipment is off',
      OTHER: 'Other',
      OTHERS: 'Others',
      CHANGE_OF_OPERATING_LEVEL: 'Change of operating level',
      EQUIPMENT_START_STOP: 'Equipment start/stop',
      SPURIOUS_ALARM: 'Spurious alarm',
      USEFUL: 'Useful',
      NOT_USEFUL: 'Not useful',
    },
  },
  snackbarMessages: {
    success: {
      title: 'Success',
      message: 'Event updated successfully',
    },
    error: {
      title: 'Error',
      message: 'Error updating event',
      upload: 'Error uploading file',
      file_size: 'The file is bigger than the allowed size',
      file_extension: 'The file extension is not allowed',
    },
  },
};
